export default __webpack_public_path__ + "static/media/Belt of the Milites Templi.a7bcc23c.jpg";